import Metadata from "./Metadata";

export default Metadata;
